/**
 * Sub-steps of the manual enter-data form. Each step groups the on-screen
 * sections rendered in `OnboardingDataEntry.vue`; every completeness area in
 * `useOnboardingDataCompleteness` is tagged with the step its fields live on,
 * so validation and the "continue" guard can be scoped to the current step.
 * `hintKey` explains why the step's data is needed (shown above its sections).
 */
export const ONBOARDING_FORM_STEPS = [
  {
    key: 'company',
    labelKey: 'onboarding.wizard.form-steps.company',
    hintKey: 'onboarding.wizard.form-steps.hints.company',
  },
  {
    key: 'contacts',
    labelKey: 'onboarding.wizard.form-steps.contacts',
    hintKey: 'onboarding.wizard.form-steps.hints.contacts',
  },
  {
    key: 'brand',
    labelKey: 'onboarding.wizard.form-steps.brand',
    hintKey: 'onboarding.wizard.form-steps.hints.brand',
  },
  {
    key: 'connections',
    labelKey: 'onboarding.wizard.form-steps.connections',
    hintKey: 'onboarding.wizard.form-steps.hints.connections',
  },
] as const

export type OnboardingFormStepKey = (typeof ONBOARDING_FORM_STEPS)[number]['key']
